import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var MC_EVENT_CATEGORY = 'StudentReport';
var ManageCurriculumEvents = {
    manageCurriculumTopicEnable: MC_EVENT_CATEGORY + "_ManageCurriculum_TopicOn",
    manageCurriculumTopicDisable: MC_EVENT_CATEGORY + "_ManageCurriculum_TopicOff",
};
var useManageCurriculumAnalytics = function () {
    return useFeatureGoogleAnalytics(MC_EVENT_CATEGORY);
};
export { useManageCurriculumAnalytics, ManageCurriculumEvents };
